module.exports = __webpack_public_path__ + "static/media/ruler-combined.88c9da59.svg";